module.exports = "/images/trec-preview-4.jpg?c658c6839abcbe8c850b94dc943a35d4";